export default {
  subtitle: 'The LaTeX the body of the report is rendered from. Leave it empty to use the default content.',
};
